import { FEATURE_INITIALIZE, FEATURE_UPDATE } from '../actions/feature';
import { AUTHENTICATION_INVALIDATE } from '../actions/api/auth';
import { camelCase } from 'change-case';

const normalize = (features = {}, state = {}) =>
  Object.keys(features).reduce(
    (o, k) => ({
      ...o,
      [camelCase(k)]: features[k].current || features[k]
    }),
    { ...state }
  );

export default function feature(state = {}, { type, payload = {} }) {
  switch (type) {
    case AUTHENTICATION_INVALIDATE:
      return {};
    case FEATURE_INITIALIZE:
      return normalize(payload);
    case FEATURE_UPDATE:
      return normalize(payload, state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/feature.js